import { render, staticRenderFns } from "./DeleteSurvey.vue?vue&type=template&id=2cf49f61&"
import script from "./DeleteSurvey.vue?vue&type=script&lang=js&"
export * from "./DeleteSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports